import { j as m, c as o } from "./utils-BdNIfrGQ.js";
import { I as e, s as i } from "./Image-Ct1HaCUq.js";
import "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import { F as t } from "./Flex-BA9xHq_p.js";
import "./Grid-DJGISvmf.js";
import "react";
const j = ({ size: a, variant: r, ...s }) => /* @__PURE__ */ m.jsx(t, { className: o(i({ size: a })), spacing: s.spacing, children: /* @__PURE__ */ m.jsx(
  e,
  {
    src: s.src,
    className: `border-gray-700 shadow-sm object-cover ${r ? "" : "rounded-md"}`,
    variant: r,
    ...s
  }
) });
export {
  j as T
};
